/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-10 17:57:13
 * @FilePath: \app-client-h5\src\pages\orderDetail\index.jsx
 */
import React, { Component } from 'react';
import {
    Toast,
} from 'antd-mobile';
import { getOrderDetail } from "./services";
import {getQueryVariable} from '../../utils/util'
import './index.scss';
class OrderDetail extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            orderData:''
        }
    }
    componentDidMount() {
        let orderNo = getQueryVariable('orderNo')
        this.getOrderDetail({orderNo})
    }
    getOrderDetail = (params)=>{
        getOrderDetail(params).then((res) =>{
            console.log(res,'/');
            if (res.code == '200'&&res.data) {
                this.setState({
                    orderData:res.data
                })
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        })
    }
    render() {
        const {orderData} = this.state;
        const {waterNum = '', projectName ='',areaName ='',buildingName ='',floorName ='',roomName ='',
        orderNo ='',payTypeId ='',amount ='',createdTime ='',execStatus ='',payTypeName} = orderData;

        return (
            <div className='orderDetail-container'>
                <div className='order-box'>
                    <div className = 'top'> 
                        <span className = 'front'>买水量：<span className='value'>{waterNum||'--'}</span>吨</span>
                        {execStatus=="待执行到水表"&&<span className = 'right color-wait'>待执行到水表</span>}
                        {execStatus=="执行中"&&<span className = 'right color-wait'>执行中</span>}
                        {execStatus=="已执行到水表"&&<span className = 'right color-ok'>已执行到水表</span>}
                        {execStatus=="执行失败"&&<span className = 'right color-fail'>执行失败</span>}
                        {!execStatus&&<span className = 'right color-fail'>--</span>}
                    </div>
                    <div className="w_room">
                        <span className = 'front'>充水房间：</span>
                        <span className='value'>{projectName||'--'}<span className= 'verLine'>|</span>{(roomName)||'--'}</span>
                    </div>
                    <div>
                        <span className = 'front'>订单号：</span>
                        <span className='value'>{orderNo||'--'}</span>
                    </div>
                    <div>
                        <span className = 'front'>支付方式：</span>
                        {/* {payTypeId==1&&<span className='value'>微信支付</span>}
                        {payTypeId==2&&<span className='value'>支付宝支付</span>}
                        {payTypeId==3&&<span className='value'>人工充水</span>}
                        {payTypeId==4&&<span className='value'>人工扣水</span>}
                        {!payTypeId&&<span className='value'>--</span>} */}
                        <span className='value'>{payTypeName}</span>
                    </div>
                    <div className = 'time-box'>
                        <span className = 'front'>订单时间：</span>
                        <span className='value'>{createdTime||'--'}</span>
                    </div>
                    <div className = 'text-right'>
                        <span className = 'symbol'>￥</span>
                        <span className = 'number'>{amount||'--'}</span>
                    </div>
                </div>
            </div>
        )
    }
}
export default OrderDetail;

